import { Injectable } from '@angular/core';
import { LMPagePersonalization } from '@states/models/lm-page-personalization.model';
import { LMPersonalizationPersistenceService } from '@services/lm-personalization-persistence.service';

@Injectable()
export class LMPagePersonalizationService {
  constructor(private lmSessionStorageService: LMPersonalizationPersistenceService) {}

  public getPagePersonalization(pagePersonalizationKeyParams: LMPagePersonalizationKeyParams): LMPagePersonalization {
    return this.lmSessionStorageService.getPersonalization(pagePersonalizationKeyParams.getKey());
  }

  public savePagePersonalization(pagePersonalizationKeyParams: LMPagePersonalizationKeyParams, pagePersonalizationItem: LMPagePersonalization) {
    this.lmSessionStorageService.persistPersonalization(pagePersonalizationKeyParams.getKey(), pagePersonalizationItem);
  }

  public deletePagePersonalization(pagePersonalizationKeyParams: LMPagePersonalizationKeyParams): void {
    this.lmSessionStorageService.removePersonalization(pagePersonalizationKeyParams.getKey());
  }
}

export class LMPagePersonalizationKeyParams {
  prefix?: string;
  resourceId: string;
  dataArea: string;
  actorId?: string;
  contextResourceId?: string;

  private key = '';

  getKey() {
    if (!this.key) {
      this.buildKey();
    }
    return this.key;
  }

  private buildKey(): void {
    if (this.prefix) {
      this.key += this.prefix + '_';
    }

    this.key += this.dataArea + '_' + this.resourceId.replace('.', '_');

    if (this.contextResourceId) {
      this.key += '_' + this.contextResourceId.replace('.', '_');
    }

    if (this.actorId) {
      this.key += '_' + this.actorId;
    }
  }
}
